<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5KyVuC/tc-custom/9780226472492.jpg?1722568412705" alt="This image is the cover for the book Socrates and the Jews"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Socrates and the Jews
      </h1>
      <p class="bookDescription body article font2">
        <p>"What has Athens to do with Jerusalem?” Asked by the early Christian Tertullian, the question was vigorously debated in the nineteenth century. While classics dominated the intellectual life of Europe, Christianity still prevailed and conflicts raged between the religious and the secular. Taking on the question of how the glories of the classical world could be reconciled with the Bible, <i>Socrates and the Jews</i> explains how Judaism played a vital role in defining modern philhellenism.</p>Exploring the tension between Hebraism and Hellenism, Miriam Leonard gracefully probes the philosophical tradition behind the development of classical philology and considers how the conflict became a preoccupation for the leading thinkers of modernity, including Matthew Arnold, Moses Mendelssohn, Kant, Marx, Nietzsche, and Freud. For each, she shows how the contrast between classical and biblical traditions is central to writings about rationalism, political subjectivity, and progress. Illustrating how the encounter between Athens and Jerusalem became a lightning rod for intellectual concerns, this book is a sophisticated addition to the history of ideas.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Miriam Leonard
      </h2>
      
      <p class="authorDescription body article"><P><B>Miriam Leonard</B> is professor of Greek literature and its reception at University College London. She is the author of <I>Athens in Paris</I>and <I>How to Read Ancient Philosophy</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?597657bc